import * as TankNotificationsActions from "../actions/tank-notifications.actions";

const initialState: any = null;

export function tankNotificationsReducer(
  state: any = initialState,
  action: TankNotificationsActions.Actions) {
  switch (action.type) {
    case TankNotificationsActions.SET_CURRENT_TANK_NOTIFICATIONS:
      if (action.currentTankNotifications) return action.currentTankNotifications;
      break;
    default:
      return state;
  }
  return state;
}
